import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Shell from "@/components/Shell";
import { Loader2, UserPlus } from "lucide-react";

export default function Users() {
    const [users, setUsers] = useState(null);
    const [form, setForm] = useState({ email: "", name: "", password: "", role: "contractor" });
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const load = async () => {
        const { data } = await api.get("/users");
        setUsers(data);
    };
    useEffect(() => { load(); }, []);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setErr("");
        try {
            await api.post("/users", form);
            setForm({ email: "", name: "", password: "", role: "contractor" });
            load();
        } catch (e2) {
            setErr(e2.response?.data?.detail?.toString() || "Creation failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <Shell>
            <div className="label-typed tw-prefix mb-2">Personnel File · Control Only</div>
            <h1 className="font-heading text-5xl tracking-[0.04em] uppercase text-ink mb-8">Operatives</h1>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <form onSubmit={submit} className="lg:col-span-1 paper-card tape-corner p-6 tilt-l" data-testid="create-user-form">
                    <div className="label-typed tw-prefix mb-3">Provision new operative</div>
                    {["name", "email", "password"].map((k) => (
                        <div key={k} className="mb-4">
                            <label className="label-typed block mb-1">{k}</label>
                            <input
                                type={k === "password" ? "password" : k === "email" ? "email" : "text"}
                                value={form[k]}
                                onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                                required
                                className="w-full px-3 py-2 text-sm"
                                data-testid={`user-field-${k}`}
                            />
                        </div>
                    ))}
                    <div className="mb-4">
                        <label className="label-typed block mb-1">role</label>
                        <select
                            value={form.role}
                            onChange={(e) => setForm({ ...form, role: e.target.value })}
                            className="w-full px-3 py-2 text-sm"
                            data-testid="user-field-role"
                        >
                            <option value="contractor">Contractor (field)</option>
                            <option value="internal">Internal (control)</option>
                        </select>
                    </div>
                    {err && (
                        <div className="text-stamp-red label-typed mb-3" data-testid="user-create-error">
                            {err}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={busy}
                        className="w-full bg-ink text-paper-light hover:bg-stamp-red px-4 py-2 font-heading uppercase text-xs tracking-[0.25em] inline-flex items-center justify-center gap-2 disabled:opacity-50"
                        data-testid="user-create-submit"
                    >
                        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <UserPlus className="w-3 h-3" />}
                        Provision
                    </button>
                </form>

                <div className="lg:col-span-2 paper-card tilt-r">
                    <div className="px-6 py-3 border-b border-ink/20 label-typed tw-prefix">
                        Active personnel
                    </div>
                    {users === null ? (
                        <div className="p-6 text-ink-soft label-typed flex items-center gap-2">
                            <Loader2 className="w-3 h-3 animate-spin" /> Opening the register...
                        </div>
                    ) : (
                        <table className="w-full font-body text-sm" data-testid="users-table">
                            <thead>
                                <tr className="border-b border-ink/20 label-typed">
                                    <th className="text-left px-6 py-3">Name</th>
                                    <th className="text-left px-6 py-3">Email</th>
                                    <th className="text-left px-6 py-3">Role</th>
                                    <th className="text-left px-6 py-3">Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map((u) => (
                                    <tr key={u.id} className="border-b border-ink/10" data-testid={`user-row-${u.email}`}>
                                        <td className="px-6 py-3 text-ink">{u.name}</td>
                                        <td className="px-6 py-3 text-ink-soft">{u.email}</td>
                                        <td className="px-6 py-3">
                                            <span className={`px-2 py-0.5 border-2 text-[10px] font-heading tracking-[0.22em] ${u.role === "internal" ? "border-stamp-red text-stamp-red" : "border-stamp-blue text-stamp-blue"}`}>
                                                {u.role.toUpperCase()}
                                            </span>
                                        </td>
                                        <td className="px-6 py-3 text-ink-faint label-typed">{u.created_at?.slice(0, 10)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </Shell>
    );
}
